import useIdentity from "@/features/ui/hooks/use-identity";
import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import BuyerMyAccountPage from "@/features/my-account/buyer-my-account-page";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function MyAccountPage() {
  return (
    <>
      <Helmet>
        <title>Pathrade | My Account</title>
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta property="og:title" content="Pathrade | My Account" />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      <BuyerMyAccountPage />
    </>
  );
}
